import { useTranslation } from 'react-i18next'
import useCustomerInvoice from 'hooks/useCustomerInvoice'
import TextPaper from '@ui/elements/TextPaper'
import { useConfirmCustomer } from '@user/customer/confirmation/useConfirmCustomer'
import { hasTextPaperLines } from '@user/customer/confirmation/getTextPaperStatus'

interface Props {
  onPress: () => void
}

export default function InvoiceDetails({ onPress }: Props) {
  const { t } = useTranslation(['ui', 'modals'])

  const { data: invoice } = useCustomerInvoice()
  const { needsInvoice, getDetailStatus } = useConfirmCustomer()

  const {
    firstName,
    lastName,
    vat,
    email,
    mobile,
    street,
    street2,
    zip,
    city,
    country_code,
  } = invoice || {}

  const country_name = country_code
    ? t(`countries:${country_code.toLowerCase()}`)
    : undefined

  const lines = [
    [firstName, lastName].filter(Boolean).join(' '),
    vat,
    email,
    mobile,
    [street, street2].filter(Boolean).join(' '),
    [zip, city].filter(Boolean).join(' '),
    [country_name, country_code].filter(Boolean).join(' '),
  ]

  const status = getDetailStatus({
    hasData: hasTextPaperLines(lines),
    isValid: !needsInvoice,
    section: 'invoice',
  })

  return (
    <TextPaper
      onPress={onPress}
      icon="file-invoice"
      label={t('modals:invoice.title')}
      lines={lines}
      status={status}
    />
  )
}
